module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av461-11058fe70d18ef13541b8845374528e5.jpg";